//import { getAuthorizationBearer } from "./endpoint";

export async function getPrograms(quicksearch?: string)
    : Promise<any> {
    let parameters = [
        quicksearch ? `fn=${quicksearch}` : '',
    ];

    let urlParameters = parameters.some(s => s !== '')
        ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    //TODO: need to uncomment once ABF team will be implemented lookups endpoint for programs
    // let url: string = `api/abf/lookups/programs${urlParameters}`;
    // const response = (await fetch(url, {
    //     method: 'GET',
    //     headers: new Headers({
    //         "Authorization": getAuthorizationBearer()
    //     }),
    // }));
    // const json = await response.json();
    const json = [{ id: 1, value: 'Program 1' }, { id: 2, value: 'Program 2' }, { id: 3, value: 'Program 3' }];
    return json.map(i => ({
        id: +i.id,
        name: `${i.value} - ${i.id}`
    }))
}